import * as React from 'react'
import { observer } from 'mobx-react'
import { JobItemViewModel } from './JobItemViewModel'
import { isNotNil } from 'utils/object-util'
import link from 'infra/link'
import Avatar from 'components/Avatar'
import UnreadBadge from 'components/UnreadBadge'
import {
  SplitViewSidebarListItem,
  SplitViewSidebarListItemTitle,
  SplitViewSidebarListItemSubtitle,
  SplitViewSidebarListItemPretitle,
} from 'components/SplitView'
import styles from './JobItem.sass'

interface JobItemProps {
  vm: JobItemViewModel
}

export default observer(function JobItem({ vm }: JobItemProps) {
  const collaboratorNames = getCollaboratorNames(vm)

  return (
    <SplitViewSidebarListItem
      to={vm.job.id ? link.job(vm.job.id) : ''}
      active={vm.isActive}
      visual={
        <Avatar
          exclaim={!!vm.latestOpenTicket}
          size={32}
          subject={vm.collaborators.map((c) => c)}
        />
      }
      extras={
        <div className={styles.stats}>
          <span className={styles.lastActivity}>{vm.lastActivity}</span>
          {vm.unreadCount > 0 && (
            <span className={styles.unread}>
              <UnreadBadge count={vm.unreadCount} />
            </span>
          )}
        </div>
      }
    >
      {vm.isWorkspaceInfoRelevant && (
        <SplitViewSidebarListItemPretitle title={vm.job.workspace.name}>
          {vm.job.workspace.name}
        </SplitViewSidebarListItemPretitle>
      )}
      <SplitViewSidebarListItemTitle title={vm.jobName}>
        {vm.jobName}
      </SplitViewSidebarListItemTitle>
      <SplitViewSidebarListItemSubtitle title={collaboratorNames}>
        {collaboratorNames}
      </SplitViewSidebarListItemSubtitle>
    </SplitViewSidebarListItem>
  )
})

function getCollaboratorNames(vm: JobItemViewModel) {
  return (
    vm.collaborators
      .map((c) => c.displayName)
      .filter(isNotNil)
      .join(', ') || 'just you'
  )
}
